import { render } from "./pcTabsBar.vue?vue&type=template&id=d7796b86&ts=true"
import script from "./pcTabsBar.vue?vue&type=script&lang=ts"
export * from "./pcTabsBar.vue?vue&type=script&lang=ts"

import "./pcTabsBar.vue?vue&type=style&index=0&id=d7796b86&lang=scss"

import exportComponent from "/home/ssh/jigoucode/jigou_fe_v5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__